import {
  Badge as MantineBadge,
  Tooltip,
  BadgeProps as MantineBadgeProps,
  Stack,
} from "@mantine/core"
import React from "react"

export const BadgeVariant = {
  INFO: "info",
  INFO_BLUE: "info-blue",
  WARNING: "warning",
  SUCCESS: "success",
  ERROR: "error",
  PRIMARY: "primary",
  PRIMARY_CRITICAL: "primary-critical",
  SECONDARY: "secondary",
  ADMIN: "admin",
} as const

export type BadgeProps = {
  text: string
  color?: string
  icon?: React.ReactNode
  variant?: (typeof BadgeVariant)[keyof typeof BadgeVariant]
  tooltipLabel?: string
  isShort?: boolean
  h?: string
} & MantineBadgeProps

export type BadgeVariant = (typeof BadgeVariant)[keyof typeof BadgeVariant]
export function Badge({
  text,
  icon,
  color,
  variant,
  tooltipLabel,
  isShort = false,
  h = "fit-content",
  ...props
}: BadgeProps) {
  const badge = (
    <MantineBadge
      variant={variant}
      color={!variant ? color : undefined} // do this to not override variant
      leftSection={isShort ? null : (icon ?? null)}
      w="max-content"
      size="md"
      h={h}
      {...props}
    >
      {isShort ? (
        <Stack h="100%" align="center">
          {icon}
        </Stack>
      ) : (
        text
      )}
    </MantineBadge>
  )
  return isShort || tooltipLabel ? (
    <Tooltip label={tooltipLabel || text}>{badge}</Tooltip>
  ) : (
    badge
  )
}
